import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { PurchaseOrderService } from '../../../services/purchaseOrder.service';
import { CnaeService } from '../../../services/cnae.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { UserService } from '../../../services/user.service';
import { CompaniesService } from '../../../services/companies.service';
import { ConsultantService } from '../../../services/consultant.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { Dimension, PurchaseOrder, Ratio } from '../../../models/PurchaseOrder.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { Approver } from '../../../models/Approver.model';
import { Responsible } from '../../../models/Responsible.model';
import { Company } from '../../../models/Company.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { DropDownList } from '../../../models/DropDownList.model';
import * as _ from 'lodash';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingPeriodBlockService } from '../../../services/accountingBlock.service';
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { PurchaseOrderType } from '../../../shared/enums/PurchaseOrderType';

@Component({
    selector: 'app-purchase-order-create',
    templateUrl: './purchase-order-create.component.html',
    styleUrls: ['./purchase-order-create.component.css']
})
export class PurchaseOrderCreateComponent implements OnInit {
    @ViewChild("openModalRecurrent") openModalRecurrent: ElementRef;
    purchaseForm: FormGroup;
    loading: boolean;
    commonHelper: CommonHelper = new CommonHelper();
    competences = this.competenceProvider.competences;
    competenceYears = this.commonHelper.listLastYears();
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    purchaseOrder: PurchaseOrder = new PurchaseOrder();
    managers: Responsible[] = new Array<Responsible>();
    consultants: any[] = new Array<any>();
    companies: any[] = new Array<any>();
    customers: any[] = new Array<any>();
    projects: any[] = new Array<any>();
    itemNotFound: boolean = false;
    showDefaultItems: boolean = false;
    purchaseOrderRecurrent: Boolean = false;
    valueAux: number = 0;
    percentAux: number = 0;
    loggedUser;
    eaPurchaseOrder: boolean = true;

    items = [];
    itemsPurchaseOrder = [];
    itemAux: any = {
        sapItemCode: '',
        itemName: '',
        customer: {},
        project: {},
        percentage: 0,
        quantity: 1,
        value: 0
    }

    itemsDropdown = {
        list: [], options: null, selected: []
    };
    defaultItemsDropdown = {
        list: [], options: null, selected: []
    };
    managersDropdown = {
        list: [], options: null, selected: []
    }
    companiesDropdown = {
        list: [], options: null, selected: []
    };
    customersDropdown = {
        list: [], options: null, selected: []
    };
    projectsDropdown = {
        list: [], options: null, selected: []
    };
    purchaseOrderTypeDropdown = {
        list: [], options: null, selected: []
    };

    apportionment: any = {};
    valueTotalQuantity;

    recurrenceList = [];
    recurrentAux = {
        competence: 0,
        competenceYear: 0,
        dueDate: new Date(),
        recurrent: 1
    }
    accountingBlock = new AccountingPeriodBlock();
    purchaseOrderTypeModels = new PurchaseOrder()
    isBlanketAgreement;
    datePickerStart: string = "";
    datePickerEnd: string = "";
    notAllowedToAddItem = true;

    constructor(
        private formBuilder: FormBuilder,
        private competenceProvider: CompetenceProvider,
        private purchaseService: PurchaseOrderService,
        private cnaeService: CnaeService,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private userService: UserService,
        private companyService: CompaniesService,
        private consultantService: ConsultantService,
        private projectFinancialService: ProjectFinancialService,
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        private accountingBlockService: AccountingPeriodBlockService
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
            .find(({type}: AccountingPeriodBlock) => type === AccountingType.PurchaseOrder);

        this.purchaseForm = this.formBuilder.group({
            value: [null, Validators.required],
            requester: [null, [this.validateSelectOptionRequester]],
            competence: [null, [this.validateSelectOption]],
            competenceYear: [null, [this.validateSelectOption]],
        });

        this.loggedUser = this.localStorage.retrieve('user');
        this.purchaseOrder.requester.name = this.loggedUser.name;
        this.purchaseOrder.dueDate = new Date();

        this.managers = await this.userService.getUsersByType(['manager']);
        this.managers = _.orderBy(this.managers, [manager => manager.name.toUpperCase()]);

        this.companies = await this.companyService.listVendors();
        this.companies = this.companies.map(company => ({ ...company, name: company.companyName }));

        this.consultants = await this.consultantService.listAll(false);
        this.consultants = this.consultants
            .filter(consultantFilter => consultantFilter.sapCardCode &&
                                        consultantFilter.contract &&
                                        consultantFilter.contract.kind == 1)
            .map(consultantMap => {
                return {
                    _id: consultantMap._id,
                    name: consultantMap.contract.companyName,
                    cnpj: consultantMap.contract.cnpj,
                    sapCardCode: consultantMap.sapCardCode
                }
            });

        const projectsAndCustomer = await this.projectFinancialService.getProjectsAndCustomers();
        const companyGroupWithCustomer = await this.companyService.getCompanyGroupsWithCustomer();
        this.customers = companyGroupWithCustomer.customers;
        this.projects = projectsAndCustomer.projects;

        this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
        this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);

        this.managersDropdown.options = this.dropDownSettingFactory.build({text:'Gestores',singleSelection:false,enableCheckAll:false});
        this.managersDropdown.list = this.dropDownItemFactory.build({source:this.managers});

        let vendorsDropdownAux = this.dropDownItemFactory.build({source:this.companies});
        vendorsDropdownAux = vendorsDropdownAux.map(vendor => ({ ...vendor, type: 'Fornecedor - Empresa' }));
        let consultantDropdownAux = this.dropDownItemFactory.build({source:this.consultants});
        consultantDropdownAux = consultantDropdownAux.map(consultant => ({ ...consultant, type: 'Fornecedor - Consultor PJ' }));

        this.companiesDropdown.options = this.dropDownSettingFactory.build({text:'Fornecedores',singleSelection:true,enableCheckAll:false,groupBy:'type'});
        this.companiesDropdown.list = vendorsDropdownAux.concat(consultantDropdownAux);

        this.purchaseOrderTypeDropdown.list = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllPurchaseOrderType(), "PurchaseOrderType");
        this.purchaseOrderTypeDropdown.options = this.commonHelper.getDropDownSettings(true, 'Tipo', true, "", "", true,null, '');

        this.customersDropdown.options = this.dropDownSettingFactory.build({text:'Clientes',singleSelection:true,enableCheckAll:false});
        this.customersDropdown.list = this.dropDownItemFactory.build({source:this.customers});

        this.projectsDropdown.options = this.dropDownSettingFactory.build({text:'Projetos',singleSelection:true,enableCheckAll:false});
        this.projectsDropdown.options["disabled"] = true;
        this.projectsDropdown.list = this.dropDownItemFactory.build({source:this.projects});

        this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:true,enableCheckAll:false});
        this.itemsDropdown.options["disabled"] = true;

        this.defaultItemsDropdown.options = this.dropDownSettingFactory.build({text:'Itens pré-selecionados',singleSelection:true,enableCheckAll:false});
        this.defaultItemsDropdown.options["disabled"] = true;

        this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});

        if(this.accountingBlock && this.accountingBlock.competenceYear && this.accountingBlock.competence){
            this.datePickerOptions.minDate = new Date(this.accountingBlock.competenceYear,this.accountingBlock.competence,1);
        }

        this.loading = false;
    }

    changePurchaseOrderType(){
        this.clearItemAux();
        if (!this.purchaseOrderTypeDropdown.selected[0] || !this.purchaseOrderTypeDropdown.selected[0].id) return;
        if(Number(this.purchaseOrderTypeDropdown.selected[0].id) == PurchaseOrderType.PurchaseOrder){
            this.purchaseOrder.isBlanketAgreement = false
            this.isBlanketAgreement = false;
            return;
        }
        this.purchaseOrder.isBlanketAgreement = true
        this.isBlanketAgreement = true;
    }

    async save(){
        try{
            if(!this.isBlanketAgreement && Number(this.purchaseOrder.paymentMethod) == 0) {
                this.toastr.warning('É obrigatório o preenchimento da Forma de Pagamento');
                return;
            }

            for(let i of this.itemsPurchaseOrder)
                if(!i.value || i.value == 0){
                    this.toastr.warning('Todos os itens precisam ter valores atribuídos');
                    return;
                }

            if(this.purchaseOrderRecurrent && this.recurrenceList.length > 0) {
                for(let recurrence of this.recurrenceList)
                    if(recurrence.competence == 0 || recurrence.competenceYear == 0 || !recurrence.dueDate) {
                        this.toastr.warning('Todos os dados da recorrência precisam ser preenchidos!', 'Recorrência inválida');
                        return;
                    }
            }

            if(Math.abs(Number(this.valueTotalQuantity.toFixed(2))) != Math.abs(Number(this.purchaseOrder.value.toFixed(2)))){
                this.toastr.warning('A soma dos valores rateados nos items e/ou eixos não correspondem com o valor total do pedido', 'Rateio inválido')
                return;
            }

            let companyAux = this.companies.find(c => c._id === this.purchaseOrder.company._id);
            if(!companyAux)
                companyAux = this.consultants.find(c => c._id === this.purchaseOrder.company._id);
            if(!companyAux) {
                this.toastr.warning('Fornecedor é obrigatório'); return;
            }

             //associação de competencia no pedido guarda-chuva - desenvolvimento paliativo
             if(this.purchaseOrder.isBlanketAgreement) {
                if(!this.purchaseOrder.startDate || !this.purchaseOrder.endDate) {
                    return this.toastr.warning('As datas inicial e final são obrigatórias no pedido guarda chuva');
                } else if(this.purchaseOrder.endDate < this.purchaseOrder.startDate) {
                    return this.toastr.warning('A data final deve ser maior que a data de início do pedido de compra guarda chuva');
                }

                const [competenceYear, competence] = this.datePickerStart.split('-')
                this.purchaseOrder.competence = Number(competence);
                this.purchaseOrder.competenceYear = Number(competenceYear);
            }

            if(this.purchaseOrder.competenceYear && this.purchaseOrder.competence &&
                this.purchaseOrder.competenceYear != 0 && this.purchaseOrder.competence != 0) {
                const isInvalid = isBlockPeriodInvalid({
                    competence: this.purchaseOrder.competence,
                    competenceYear: this.purchaseOrder.competenceYear
                }, this.accountingBlock)
                if (isInvalid) {
                    return this.toastr.warning(`A competência ${this.competenceProvider.findCompetence(this.purchaseOrder.competence)}/${this.purchaseOrder.competenceYear}, está dentro do intervalo de bloqueio. Por favor selecione uma data diferente antes de cadastrar o pedido.`, 'Bloqueio Contábil', {
                        toastLife:8000,
                        showCloseButton: true
                    });
                }
            }

            this.purchaseOrder.company.sapCardCode = companyAux ? companyAux.sapCardCode : '';
            this.purchaseOrder.company.name = companyAux ? companyAux.name : '';
            this.purchaseOrder.company.cnpj = companyAux ? companyAux.cnpj : '';

            this.purchaseOrder.items = this.itemsPurchaseOrder;

            this.loading = true;
            let response;
            if(this.purchaseOrderRecurrent && this.recurrenceList.length > 0) {
                const purchaseOrders = this.buildRecurrencePurchaseOrder(this.recurrenceList);
                response = await this.purchaseService.createRecurrence(purchaseOrders);
                this.loading = false;
                if(response && response.length > 0){
                    if(response[0].status == 400 || response[0].status == 500){
                        let msg = JSON.parse(response[0]._body);
                        this.toastr.error(msg.message);
                    } else {
                        this.toastr.success(`Os ${this.recurrenceList.length} pedidos de compra recorrentes foram criados com sucesso`);
                        this.router.navigate(['/purchase-orders']);
                    }
                }
            } else {
                response = await this.purchaseService.create(this.purchaseOrder);
                this.loading = false;
                if(response._id){
                    this.toastr.success('Pedido de compra criado com sucesso');
                    this.router.navigate(['/purchase-orders']);
                } else {
                    this.toastr.warning('Erro ao salvar Pedido de Compra');
                }
            }

        } catch(err){
            this.loading = false;
            this.toastr.warning('Verifique se preencheu corretamente todos os campos obrigatórios', 'Erro ao salvar Pedido de Compra');
        }
    }

    onDatePickerChange() {
        this.purchaseOrder.startDate = this.datePickerStart ? new Date(`${this.datePickerStart}-01`) : null;
        this.purchaseOrder.endDate = this.datePickerEnd ? new Date(`${this.datePickerEnd}-01`) : null;
        if(this.purchaseOrder.endDate < this.purchaseOrder.startDate){
            this.toastr.warning('A data final deve ser maior que a data de início do pedido de Compra guarda chuva');
            return
        }
    }

    buildRecurrencePurchaseOrder(recurrenceList) {
        let build = [];
        const anticipationCode = this.randomPurchaseJoinGenerator(4);
        for(let recurrenceItem of recurrenceList) {
            const purchaseOrder = {
                ...this.purchaseOrder,
                competence: recurrenceItem.competence,
                competenceYear: recurrenceItem.competenceYear,
                dueDate: recurrenceItem.dueDate,
                anticipationCode: this.eaPurchaseOrder ? anticipationCode : '',
            }
            build.push(purchaseOrder);
        }
        return build;
    }

    randomPurchaseJoinGenerator = (length = 2) => {
        const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let code = '';
        for (let i = 0; i < length; i++) {
            code += letters[Math.floor(Math.random() * 26)];
            code += numbers[Math.floor(Math.random() * 10)];
        }
        return code;
    }

    cancel() {
        this.purchaseOrder = new PurchaseOrder();
        this.purchaseOrder.requester.name = this.loggedUser.name;
        this.managersDropdown.selected = [];
        this.companiesDropdown.selected = [];
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.itemsPurchaseOrder = [];
    }

    changeVisibleItems(){
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        if(this.itemNotFound){
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: false }
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: true }
        } else {
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: true }
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: false }
        }
    }

    changeCompany(){
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.itemsPurchaseOrder = [];
        let listDefaultItems = [];

        if(this.companiesDropdown.selected.length == 0){
            this.purchaseOrder.company._id = '';
        } else {
            this.purchaseOrder.company._id = this.companiesDropdown.selected[0].id;
        }

        const companySelect = this.companies.find(c => c._id === this.purchaseOrder.company._id);
        if(companySelect && companySelect.defaultItems && companySelect.defaultItems.length > 0){
            companySelect.defaultItems.forEach(item => {
                const itemDefault = this.items.find(i => i.sapItemCode === item);
                listDefaultItems.push({
                    id: itemDefault._id,
                    itemName: itemDefault.name,
                    sapItemCode: itemDefault.sapItemCode
                });
            });
        }
        this.defaultItemsDropdown.list = listDefaultItems;
        if(listDefaultItems.length > 0){
            this.showDefaultItems = true;
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: false }
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: true }
        } else {
            this.showDefaultItems = false;
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: true }
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: false }
        }
    }

    changeCustomer() {
        this.projectsDropdown.selected = [];
        if(this.customersDropdown.selected.length > 0){
            const customerId = this.customersDropdown.selected[0].id;
            this.projectsDropdown.list = this.dropDownItemFactory.build({
                source: this.projects.filter(p => p.companyId == customerId)
            });
            this.projectsDropdown.options = { ...this.projectsDropdown.options, disabled: false }
        } else {
            this.projectsDropdown.list = [];
            this.projectsDropdown.options = { ...this.projectsDropdown.options, disabled: true }
        }
    }

    addItem() {
        let itemSelected;
        const customer = this.customersDropdown.selected.length > 0 ? this.customersDropdown.selected[0] : null;
        const project = this.projectsDropdown.selected.length > 0 ? this.projectsDropdown.selected[0] : null;
        if(this.defaultItemsDropdown.selected.length > 0)
            itemSelected = this.items.find(i => i._id === this.defaultItemsDropdown.selected[0].id);
        else if(this.itemsDropdown.selected.length > 0)
            itemSelected = this.items.find(i => i._id === this.itemsDropdown.selected[0].id);

        this.itemsPurchaseOrder.push({
            sapItemCode: itemSelected.sapItemCode,
            itemName: itemSelected.name,
            customer: customer ? { '_id': customer.id, 'name': customer.itemName, 'industry': customer.industry || {} } : null,
            project: project ? { '_id': project.id, 'name': project.itemName } : null,
            percentage: 0,
            quantity: 1,
            value: 0
        });

        this.clearItemAux();
    }

    removeItem(i) {
        this.itemsPurchaseOrder.splice(i, 1);
    }

    clearItemAux() {
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.customersDropdown.selected = [];
        this.projectsDropdown.selected = [];
        this.itemAux = {
            sapItemCode: '',
            itemName: '',
            customer: {},
            project: {},
            percentage: 0,
            value: 0
        };
    }

    verifyValidTouched(fieldName) {
        return !this.purchaseForm.get(fieldName).valid && this.purchaseForm.get(fieldName).touched;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value != 0 || control.value != '0')
            return null;
    }

    validateSelectOptionRequester(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {requester: true};
        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    changeTotalValue() {
        this.valueTotalQuantity = this.getValuePercentageOfQuantity();
        this.percentAux = this.valueTotalQuantity * 100 / this.purchaseOrder.value
        if (Number.isNaN(this.percentAux)) {
            this.percentAux = 0;
        }
        this.valueAux = this.purchaseOrder.value - this.valueTotalQuantity
    }

    changeValue(i) {
        const percent = this.itemsPurchaseOrder[i].value / this.purchaseOrder.value * 100;
        this.itemsPurchaseOrder[i].percentage = percent;
    }

    changePercent(i) {
        const valuePercent = parseFloat(Number((this.purchaseOrder.value / 100 * this.itemsPurchaseOrder[i].percentage) * this.itemsPurchaseOrder[i].quantity).toFixed(2));
        this.itemsPurchaseOrder[i].value = valuePercent;
        this.changeTotalValue();
    }

    getValuePercentageOfQuantity() {
        let data = 0
        this.itemsPurchaseOrder.forEach(c => data += parseFloat(Number((this.purchaseOrder.value / 100 * c.percentage) * c.quantity).toFixed(2)))
        return data
    }

    changeQuantity(i) {
        this.purchaseOrder.quantity =  Number(this.itemsPurchaseOrder[i].quantity);
        this.changeTotalValue();

        if(this.valueTotalQuantity > this.purchaseOrder.value){
            this.itemsPurchaseOrder[i].quantity = 0;
            const inputElement = document.getElementById('quantity-' + i.toString()) as any
            inputElement.value = 0
            this.changeTotalValue();
            this.toastr.warning('A soma dos valores nos items não correspondem com o valor total do pedido');
        }
    }

    changePurchaseOrderRecurrent() {
        if(this.purchaseOrderRecurrent) {
            this.recurrentAux = {
                competence: 0, competenceYear: 0, dueDate: new Date(), recurrent: 1
            };
            this.openModalRecurrent.nativeElement.click();
            this.purchaseOrderTypeDropdown.selected = [];
            this.notAllowedToAddItem = true;
        } else {
            this.clearRecurrentAux();
        }
    }

    clearRecurrentAux(){
        this.recurrenceList = [];
        this.purchaseOrder.competence = 0;
        this.purchaseOrder.competenceYear = 0;
        this.purchaseOrder.dueDate = new Date();
        this.purchaseOrderRecurrent = false;
    }

    addRecurrentAux(){
        if(this.purchaseOrderRecurrent && this.recurrentAux.recurrent > 0) {
            this.purchaseOrder.competence = 0; this.purchaseOrder.competenceYear = 0;
            let competenceAux = this.recurrentAux.competence;
            let competenceYearAux = this.recurrentAux.competenceYear;
            let dueDateAux = this.recurrentAux.dueDate;
            for(let i=0; i<this.recurrentAux.recurrent; i++) {
                const recurrenceItem = {
                    competence: competenceAux,
                    competenceYear: competenceYearAux,
                    dueDate: new Date(dueDateAux)
                }
                this.recurrenceList.push(recurrenceItem);

                competenceAux++;
                if(competenceAux == 13) {
                    competenceAux = 1;
                    competenceYearAux++;
                }
                if(!this.eaPurchaseOrder) dueDateAux.setMonth(dueDateAux.getMonth()+1);
            }
        }
    }

    isRatioInvalid() {
        if (!this.purchaseOrder.industries.length ||
            !this.purchaseOrder.excellenceCenters.length ||
            !this.purchaseOrder.supportCenters.length) {
                return true;
            };
        return false;
    };

    sendModalApportionment() {
        let itemsPurchaseOrderIndustries = [];
        this.itemsPurchaseOrder.forEach(item => {
            if (item.customer && (item.customer.industry && item.customer.industry._id)) {
                itemsPurchaseOrderIndustries.push({
                    ...item.customer.industry,
                    percentage: parseFloat(item.percentage),
                    value: item.value
                })
            }
        })
        this.apportionment = {
            industries: this.apportionment.industries ? [...this.purchaseOrder.industries] : [...itemsPurchaseOrderIndustries],
            excellenceCenters: [...this.purchaseOrder.excellenceCenters],
            supportCenters: [...this.purchaseOrder.supportCenters]
        }
    }

    getApportionment(apportionment: Ratio){
        const fields = ['industries', 'excellenceCenters', 'supportCenters'];
        let distributionRatio = {...apportionment};
        fields.forEach(field => {
            distributionRatio[field] = distributionRatio[field].reduce((acc: Dimension[], item: Dimension) => {
                if (item.percentage > 0) {
                    acc.push(item);
                }
                return acc;
            }, [])
        })
        this.purchaseOrder.excellenceCenters = [...distributionRatio.excellenceCenters];
        this.purchaseOrder.supportCenters = [...distributionRatio.supportCenters];
        this.purchaseOrder.industries = [...distributionRatio.industries];
    };

    isPurchaseOrderValueNan(value: number) {
        return isNaN(value);
    }

}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order-create/purchase-order-create.component.ts